﻿$.fn.dxCtrlChartTauxVue = function custom_dxCtrlChartTauxVue(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlcharttauxvue dx-ctrl");
        this.createInstance(new cdxCtrlChartTauxVue(this, option));
    }
    return this;
}

window.cdxCtrlChartTauxVue = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var dx = null
    function mConstruit() {
        container.empty()
        container.css({ "height": "100%", "width": "100%" })
        Me.mUpdate()
    }

    function mRempli(value, data) {
        lib = "sms"
        if (option.idTableCom == option.bddCtrl.getObjet("com_email_envoi").mGetTable().id_table) lib = "email" + ((data.nb_total > 1) ? "s" : "")
        var messPlus = ((data.nb_vue == 0) ? "aucune" : data.nb_vue) + " vue" + ((data.nb_vue > 1) ? "s" : "") + "<br/>(sur " + data.nb_total + "<br/>" + lib + " délivrée" + ((data.nb_total > 1) ? "s" : "") + ")"
        container.attr("title", messPlus)
        if (dx == null) {
            dx = $("<div style='width:100%;height:100%;'/>").appendTo(container).dxCtrlIndicateurCircleIcone({
                value: value,
                icon: "fas fa-eye"
            }).dxCtrlIndicateurCircleIcone("instance")
        } else {
            dx.mUpdate(value)
        }
    }

    this.mUpdate = function (data) {
        if (typeof data == 'undefined') {
            option.bddCtrl.mAjaxCall({ command: "getresumeenvoi", id_table_com: option.idTableCom, id_com: option.idCom },
                function (data) {
                    Me.mUpdate(data.stat[0])
                })
        } else {
            var value = 0
            if (data.nb_total > 0) value = ((parseInt(data.nb_vue) > parseInt(data.nb_total)) ? 100 : Math.ceil(data.nb_vue / data.nb_total))
            mRempli(value,data)
        }
    }

    this.element = function () { return container }
    this.focus = function () { }

    mConstruit();
}